export const BLOGS_LOADING = "BLOGS_LOADING";
export const SET_BLOGS = "SET_BLOGS";